<template>
  <div class="box">
    <b-field grouped>

      <select-vetted-statement class="voaf-select is-small" @input="(vettedStatement) => filters.vettedOrderActivityId = vettedStatement ? vettedStatement.id : ''" ref="selectVettedStatement">
        <template v-slot:defaultOptionLabel>All</template>
      </select-vetted-statement>
      <select-group class="voaf-select is-small" @input="(id) => filters.groupId = id" ref="selectGroup">
        <template v-slot:defaultOptionLabel>All</template>
      </select-group>
      <select-status class="voaf-select is-small" @input="(id) => filters.statusId = id" ref="selectStatus">
        <template v-slot:defaultOptionLabel>All</template>
      </select-status>
      <select-problem class="voaf-select is-small" @input="(id) => filters.problemCodeId = id" ref="selectProblem">
        <template v-slot:defaultOptionLabel>All</template>
      </select-problem>

      <div class="field">
        <label class="label is-invisible">Actions</label>
        <div class="buttons">
          <button class="button" @click="reset">Reset</button>
          <button class="button is-dark" @click="filter">Filter</button>
        </div>
      </div>

    </b-field>
  </div>
</template>

<script>

import SelectVettedStatement from "./selectVettedStatement";
import SelectGroup from "./selectGroup";
import SelectStatus from "./selectStatus";
import SelectProblem from "./selectProblem";
import { VettedStatementService } from "@/services/vettedStatement.service.js";

export default {

  components: {
    SelectVettedStatement,
    SelectGroup,
    SelectStatus,
    SelectProblem
  },

  data: () => ({
    filters: {
      vettedOrderActivityId: "",
      groupId: "",
      statusId: "",
      problemCodeId: ""
    }
  }),

  methods: {

    filter() {

      const filters = Object.keys(this.filters).reduce((acc, key) => {
        if (this.filters[key]) {
          acc[key] = this.filters[key];
        }
        return acc;
      }, {});

      this.$emit("filter", filters);

    },

    reset() {

      this.filters = {};
      this.$refs.selectVettedStatement.reset();
      this.$refs.selectGroup.reset();
      this.$refs.selectStatus.reset();
      this.$refs.selectProblem.reset();
      this.filter();

    }

  }

};

</script>


// WEBPACK FOOTER //
// src/components/pages/VettedStatement/list/partials/filters.vue